module.exports = __webpack_public_path__ + "img/5_32.68c8788c.png";